import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { saveScenario } from 'gqlQueries/priceSimulator';
import { sendNotification } from 'utils/helperMethods';
const errorMessage: string = 'Something went wrong!';

function useSaveScenario({ setScenarioId }: any) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<Array<string> | null>([]);

    const [saveCurrentScenario] = useMutation(saveScenario, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { updateScenario } = payload;
            setScenarioId(updateScenario?.scenarioId || 0);
            sendNotification('success', 'Scenario successfully created and saved.');
            setData(updateScenario);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        console.log('error logging', error);
        sendNotification('error', 'Failed to save Scenario. Please try again.');
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        saveScenario: (variables: any) => {
            setLoading(true);
            setError(null);
            saveCurrentScenario(variables);
        },
    };
}

export { useSaveScenario };
